import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Paragraph } from "components/core/Typography";

import "./Pill.scss";

function Pill({ label = "", onClick = () => {}, labelProps = {}, className }) {

	return (
		<button
			type="button"
			className="button-pill"
			onClick={onClick}
		>
			<Paragraph
				className={classnames("pill", className)}
				{...labelProps}
			>
				{label}
			</Paragraph>
		</button>
	);
}

Pill.propTypes = {
	label: PropTypes.string,
	onClick: PropTypes.func,
	labelProps: PropTypes.object,
	className: PropTypes.string
};

export default Pill;
